import {
	createPageSegmentLoadMetric,
	VIEW_PAGE_LABELS_METRIC_KEY,
} from '@confluence/browser-metrics';

export const VIEW_PAGE_LABELS_METRIC = createPageSegmentLoadMetric({
	key: VIEW_PAGE_LABELS_METRIC_KEY,
});
